import { Component, OnInit } from '@angular/core';
import { CtxForm } from '../../../_forms/models/form.model';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthnService } from '../../../_services/authn.service';
import { Router, RouterLink } from '@angular/router';
import { CtxButtonComponent } from '../../button/button.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CtxAlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'ctx-customer-forgot-password',
  templateUrl: './customer-forgot-password.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CtxAlertComponent,
    MatFormFieldModule,
    MatInputModule,
    CtxButtonComponent,
    RouterLink,
  ],
})
export class CustomerForgotPasswordComponent extends CtxForm implements OnInit {
  constructor(
    private fb: FormBuilder,
    private authnService: AuthnService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.formGroup = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  /**
   * Performs login based on credentials entered in the form.
   */
  override async submit(): Promise<void> {
    if (!this.formGroup.valid) {
      return;
    }
    try {
      this.setState('submit', true);
      this.setState('disabled', true);
      this.resetApiMessage();
      await this.authnService.forgotPassword(
        await this.authnService.getAccountAlias(),
        this.formGroup.value.email
      );
      this.setCustomApiMessage({
        text: `Password reset instructions have been sent to ${this.formGroup.value.email}`,
        alertLevel: 'success',
      });
      setTimeout(async () => {
        await this.router.navigate(['/']);
      }, 2000);
    } catch (errorResponse) {
      this.setApiMessage(errorResponse);
    }
    this.setState('disabled', false);
    this.setState('submit', false);
  }
}
